import {
  GridFilterInputSingleSelect,
  type GridFilterOperator,
} from "@mui/x-data-grid-premium";

export const getDataGridSelectFilterOperators = (): GridFilterOperator[] => {
  return [
    {
      value: "is",
      headerLabel: "Is",
      getApplyFilterFn: (filterItem) => {
        return (value) => {
          if (!filterItem.value) {
            return false;
          }

          return value === filterItem.value;
        };
      },

      label: "Is",
      InputComponent: GridFilterInputSingleSelect,
    },
  ];
};
